/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
import axios from 'axios';
import NodeRSA from 'node-rsa';
import { PUBLIC_PG_KEY, BASE_URL_OLD } from '@/utils/api';
import store from '@/store';
import Router from '@/router';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import GeneralModule from '@/store/modules/General';

const RSA = new NodeRSA(PUBLIC_PG_KEY);

const SENSITIVE_KEY = ['userId', 'role', 'subPassword', 'password', 'confirmPassword', 'newPassword', 'oldPassword'];
const OLD_URL = BASE_URL_OLD.split('/')[2];
const GeneralInstance = getModule(GeneralModule, store);

export default function setup() {
  axios.interceptors.request.use(async (request) => {
    request.headers['x-secure-code'] = localStorage.getItem('x-secure-code');
    request.headers['x-authorize'] = localStorage.getItem('x-authorize');
    if (request.data && request.url.split('/')[2] !== OLD_URL) {
      for (let idx = 0; idx < Object.keys(request.data).length; idx += 1) {
        const key = Object.keys(request.data)[idx];
        if (SENSITIVE_KEY.includes(key)) {
          request.data = Object.assign(request.data, { [`${key}`]: RSA.encrypt(request.data[key], 'base64')});
          if (key === 'subPassword') localStorage.setItem('x-secure-code', request.data[key]);
        }
      }
    }
    return request;
  }, (err) => Promise.reject(err));

  axios.interceptors.response.use(async (response) => response,
    async (err) => {
      const originalConfig = err.config;
      const path = originalConfig.url.split('/').splice(3).join('/');
      if (!err.response) {
        GeneralInstance.toggleLoading(false);
        GeneralInstance.ShowAlert({
          isAlert: true,
          alertMsg: `Can't connect to server. Please try again later.`,
          alertColor: 'danger',
        });
      }
      if (path !== 'auth/login/agent' && err.response) {
        if (err.response.status === 500 && path === 'auth/refresh') {
          await store.dispatch('Logout');
          Router.push('/login');
        }
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            Vue.axios.defaults.headers.common.Authorization = `Bearer ${Vue.prototype.$session.get('ambgames-user-refresh-token')}`;
            await store.dispatch('RefreshToken');
            originalConfig.headers.Authorization = `Bearer ${Vue.prototype.$session.get('ambgames-user-access-token')}`;
            return axios(originalConfig);
          } catch (_error) {
            return Promise.reject(_error);
          }
        }
      }
      return Promise.reject(err);
    });
}
